import React from 'react';
import { Link } from 'react-router-dom';
import { docPathModuleGuide } from '../../data/documentationRoutes';
import DocModuleIcon from './DocModuleIcon';

const DocModuleOverview = ({ module, guides, setupIntro }) => (
  <article className="doc-page-card doc-module-card" style={{ '--doc-accent': module.accent }}>
    <header className="doc-module-header">
      <DocModuleIcon moduleId={module.id} variant="hero" accent={module.accent} />
      <div>
        <span className="doc-guide-step-pill">Setup overview</span>
        <h2 className="doc-section-title mb-1">{module.title}</h2>
        <p className="doc-module-summary mb-0">{setupIntro || module.summary}</p>
      </div>
    </header>

    <div className="doc-purpose-box">
      <strong>Purpose</strong>
      <p className="mb-0">{module.purpose}</p>
    </div>

    <h3 className="doc-subheading">Setup guides in this module</h3>
    <p className="doc-lead doc-lead-compact">
      Select a guide below to open detailed step-by-step instructions. Each guide covers one workflow in this module.
    </p>
    <div className="doc-setup-guide-grid">
      {guides.map((guide) => (
        <Link
          key={guide.id}
          to={docPathModuleGuide(module.id, guide.id)}
          className="doc-setup-guide-card"
        >
          <span className="doc-setup-guide-card-num">{guide.stepNumber}</span>
          <div>
            <h4>{guide.title}</h4>
            <p>{guide.summary}</p>
          </div>
          <span className="doc-setup-guide-card-arrow" aria-hidden="true">
            &rarr;
          </span>
        </Link>
      ))}
    </div>

    <h3 className="doc-subheading">Key features</h3>
    <div className="doc-features-grid">
      {module.features.map((feat) => (
        <div key={feat.heading} className="doc-feature-block">
          <h4>{feat.heading}</h4>
          <ul>
            {feat.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <h3 className="doc-subheading">Typical workflow</h3>
    <ol className="doc-workflow-list">
      {module.workflow.map((step, index) => (
        <li key={step}>
          <span className="doc-workflow-step">{index + 1}</span>
          <span>{step}</span>
        </li>
      ))}
    </ol>

    <div className="doc-roles-row">
      <strong>Who uses this</strong>
      <div className="doc-role-badges">
        {module.roles.map((role) => (
          <span key={role} className="doc-role-badge">
            {role}
          </span>
        ))}
      </div>
    </div>
  </article>
);

export default DocModuleOverview;
